// Trilingual translations for FootPool Events (FR / DE / IT)
// German (de) is the approved content reference. Swiss German spelling (ss, not ß).
export const LANGUAGES = [
  { code: "fr", label: "FR", name: "Français" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "it", label: "IT", name: "Italiano" },
];

export const translations = {
  /* ============================== DEUTSCH (Referenz) ============================== */
  de: {
    nav: {
      home: "Start",
      events: "Events",
      branding: "Branding",
      how: "So funktioniert's",
      pricing: "Preise",
      faq: "FAQ",
      contact: "Kontakt",
      cta: "Kostenloses Angebot anfragen",
    },
    hero: {
      badge: "⚽ Fussball trifft Billard.",
      title1: "Fussball trifft Billard.",
      title2: "Menschen treffen Marken.",
      subtitle:
        "FootPool macht aus Firmenevents gemeinsame Erlebnisse und aus Markenauftritten interaktive Begegnungen.",
      inOut: "Spielspass für drinnen und draussen.",
      cta1: "Events entdecken",
      cta2: "Branding entdecken",
      cta1Href: "#events",
      cta2Href: "#branding",
      imgAlt:
        "Gäste eines Firmenevents rund um ein FootPool-Spielfeld bei Sonnenuntergang",
    },
    events: {
      kicker: "EVENTS",
      title: "Events, die Menschen zusammenbringen.",
      subtitle:
        "Ob Teambuilding, Firmenanlass, Betriebsausflug, Sommerfest oder Weihnachtsfeier: FootPool verbindet spielerischen Wettbewerb mit gemeinsamen Erlebnissen. Einfach mitmachen, zusammen lachen und den Teamgeist stärken – ohne sportliche Vorkenntnisse.",
      spaceLine: "Benötigte freie Fläche: mindestens 10 × 4 Meter.",
      ctaLabel: "Eventpreise ansehen",
      ctaHref: "#pricing-events",
      collageAlts: [
        "Gäste bei einem FootPool-Firmenevent am Abend",
        "Freunde spielen FootPool bei einer privaten Feier am See",
        "Team feiert einen Treffer bei einem FootPool-Event in der Stadt",
      ],
      cards: [
        {
          label: "TRY IT",
          title: "Einfach ausprobieren.",
          items: [
            "Bis 12 Personen",
            "2 Stunden",
            "1 Spielfeld",
            "Lieferung, Auf- und Abbau",
            "2 FootPool-Mitarbeitende",
            "Einführung und Betreuung",
          ],
        },
        {
          label: "MAKE IT YOURS",
          title: "Ihr Event. Ihr Erlebnis.",
          items: [
            "Bis 24 Personen",
            "4 Stunden",
            "1 Spielfeld",
            "Lieferung, Auf- und Abbau",
            "Mindestens 2 FootPool-Mitarbeitende",
            "Einführung und Betreuung",
            "Siegerehrung inklusive",
            "Organisierter Turniermodus auf Wunsch inklusive",
            "Individuell erweiterbar durch separat buchbare Zusatzleistungen",
          ],
        },
        {
          label: "WE TAKE CARE OF IT",
          title: "Sie wünschen. Wir organisieren.",
          items: [
            "Individuelle Planung und Koordination",
            "Besonders für grössere oder komplexere Events",
            "Persönliche Abstimmung der Leistungen",
            "Organisationshonorar und operative Leistungen werden separat kalkuliert",
          ],
        },
      ],
    },
    branding: {
      kicker: "BRANDING",
      title: "Marken, die Menschen erleben.",
      subtitle:
        "FootPool verwandelt Markenauftritte in interaktive Erlebnisse. Menschen werden aktiv, bleiben länger und kommen miteinander ins Gespräch. Ob Messeattraktion, Promotion, Roadshow oder Aktion im Einkaufszentrum: Wir schaffen Raum für Gespräche.",
      ctaLabel: "Brandingpreise ansehen",
      ctaHref: "#pricing-branding",
      collageAlts: [
        "FootPool-Spielfeld mit individuellem Firmenbranding",
        "Partie FootPool aus der Perspektive einer Spielfeld-Tasche",
      ],
      cards: [
        {
          label: "BRANDED FOOTPOOL",
          title: "Interaktiv sichtbar.",
          items: [
            "Werbepräsenz auf einem FootPool-eigenen Spielfeld",
            "Einsatz bei geeigneten FootPool-Veranstaltungen und eigenen öffentlichen Auftritten",
            "Laufzeiten von 3, 6 oder 12 Monaten",
            "Nachweis tatsächlich erfolgter Einsätze",
            "Keine garantierte Reichweite oder Einsatzanzahl",
            "Keine exklusive Nutzung durch den Werbekunden",
          ],
        },
        {
          label: "CAMPAIGN FOOTPOOL",
          title: "Menschen interaktiv erreichen.",
          items: [
            "Exklusive Bereitstellung eines modularen FootPool-Spielfelds für die eigene Kampagne",
            "Tages-, Wochen- oder Monatsmiete",
            "Geeignet für Messen, Promotions, Roadshows und Markenaktionen",
            "Transport, Personal, Branding und Zusatzleistungen separat buchbar",
          ],
        },
        {
          label: "WE TAKE CARE OF IT",
          title: "Ihre Marke interaktiv erlebbar machen.",
          items: [
            "Individuelle Planung und Koordination einer FootPool-bezogenen Markenaktion",
            "Abstimmung von Spielfeld, Branding und Durchführung",
            "Organisationshonorar; operative Leistungen separat",
          ],
        },
      ],
    },
    how: {
      kicker: "3 einfache Schritte",
      title: "Von der Idee zum Event — im Handumdrehen.",
      steps: [
        { n: "01", t: "Buchen", d: "Wählen Sie Ihr Wunschdatum und den Veranstaltungsort. Nach Ihrer Anfrage kümmern wir uns um den Rest." },
        { n: "02", t: "Wir bauen auf", d: "Unser Team trifft rechtzeitig ein und baut das FootPool-Spielfeld professionell für Ihren Event auf." },
        { n: "03", t: "Spielen", d: "Jetzt heisst es spielen, mitfiebern und gemeinsam unvergessliche Momente erleben." },
      ],
      imgAlt: "Weisses FootPool-Spielfeld in einem hellen Veranstaltungsraum",
    },
    features: {
      kicker: "WARUM FOOTPOOL?",
      title: "Mehr als nur ein Spiel.",
      subtitle:
        "FootPool verbindet Menschen, sorgt für Bewegung und macht jeden Event zu einem besonderen Erlebnis.",
      items: [
        { t: "Professionelle Betreuung", d: "Von der ersten Anfrage bis zum erfolgreichen Event begleiten wir Sie persönlich." },
        { t: "Einfach organisiert", d: "Bei TRY IT und MAKE IT YOURS sind Lieferung, Aufbau und Abbau inklusive (Anfahrt separat). Bei Kampagnen und Organisationsaufträgen offerieren wir Transport und operative Leistungen separat." },
        { t: "Spass für alle", d: "Keine Vorkenntnisse erforderlich — einfach mitspielen und geniessen." },
        { t: "Schweizweit verfügbar", d: "Wir bringen FootPool als mobiles Eventspiel direkt zu Ihrem Veranstaltungsort – aus unserer Heimatregion Ostschweiz (St. Gallen, Rheintal, Werdenberg) schweizweit." },
      ],
      imgAlt: "Team feiert bei einem FootPool-Event in der Stadt",
    },
    occasions: {
      kicker: "PERFEKT FÜR",
      title: "Für jeden Anlass das passende Highlight",
      subtitle:
        "Ob Firmenevent, Schule, Verein oder öffentliches Fest – FootPool bringt Menschen zusammen und sorgt für Bewegung, Teamgeist und jede Menge Spass.",
      cards: {
        firmenevents: {
          t: "Firmenevents & Teambuilding",
          d: "Firmenfeste, Kick-offs, After-Work und Teamevents.",
          alt: "Weisses FootPool-Spielfeld in einem modernen Büro mit Panoramafenstern",
        },
        branding: {
          t: "Branding & Marketing",
          d: "Markenauftritte, Messen und interaktive Werbepräsenz mit FootPool.",
          alt: "FootPool-Spielfeld mit individuell gebrandeter Spielfläche",
        },
        vereine: {
          t: "Vereine",
          d: "Vereinsfeste, Saisonabschlüsse und Jubiläen.",
          alt: "Freunde spielen FootPool bei einer Feier im Freien bei Sonnenuntergang",
        },
        gemeinden: {
          t: "Gemeinden & öffentliche Events",
          d: "Dorf- und Stadtfeste, Jugendanlässe und öffentliche Veranstaltungen.",
          alt: "Kinder spielen auf einem FootPool-Spielfeld bei einem öffentlichen Fest im Grünen",
        },
        messen: {
          t: "Messen & Promotionen",
          d: "Ein interaktiver Publikumsmagnet für Messen, Promotions und spezielle Verkaufstage.",
          alt: "FootPool-Eventimpressionen mit Branding bei öffentlichen Events",
        },
        schulen: {
          t: "Schulen",
          d: "Sporttage, Klassenlager und besondere Schulanlässe.",
          alt: "Schülerinnen und Schüler spielen FootPool mit nummerierten Bällen",
        },
      },
    },
    gallery: {
      kicker: "Galerie",
      title: "Die FootPool-Energie in Bildern.",
      alts: [
        "Gebrandetes FootPool-Spielfeld in einem Büro",
        "Gäste rund um das FootPool-Spielfeld in einem Backsteinraum",
        "Team feiert bei einem FootPool-Event in der Stadt",
        "Gäste bei einem FootPool-Firmenevent am Abend",
      ],
    },
    aiNote: {
      title: "HINWEIS ZU UNSEREN BILDERN",
      body:
        "FootPool Events startet 2026 neu. Einige der auf dieser Website gezeigten Bilder wurden deshalb mit KI erstellt oder bearbeitet und dienen zur Veranschaulichung möglicher FootPool-Events und Einsatzsituationen. Sobald unsere ersten Veranstaltungen stattfinden, werden diese nach und nach durch Bilder echter FootPool Events ersetzt.\nDas Angebot, die Ausstattung und die angegebenen Leistungen sind davon selbstverständlich unabhängig und real.",
    },
    pricing: {
      kicker: "TRANSPARENT & INDIVIDUELL",
      title: "Preise & Pakete",
      subtitle:
        "Alle Preise verstehen sich exkl. MwSt. Individuelle Zusatzleistungen und Anfahrtskosten werden separat berechnet.",
      countryAria: "Land auswählen",
      countries: { CH: "Schweiz (CHF)", DE: "Deutschland (€)", AT: "Österreich (€)" },
      from: "ab",
      orgFrom: "Organisationshonorar ab",
      onRequest: "Preis auf Anfrage",
      perMonth: "/ Monat",
      eventsTitle: "Events",
      eventsTag: "Employee experience",
      offers: {
        tryIt: {
          label: "TRY IT",
          title: "Einfach ausprobieren",
          items: [
            "Bis zu 12 Personen",
            "2 Stunden Spielzeit",
            "1 FootPool-Spielfeld",
            "Lieferung, Aufbau und Abbau",
            "2 FootPool-Mitarbeitende",
            "Einführung und Betreuung",
          ],
        },
        makeItYours: {
          label: "MAKE IT YOURS",
          title: "Ihr Event. Ihr Erlebnis.",
          items: [
            "Bis zu 24 Personen",
            "4 Stunden Spielzeit",
            "1 FootPool-Spielfeld",
            "Lieferung, Aufbau und Abbau",
            "Mindestens 2 FootPool-Mitarbeitende",
            "Einführung und Betreuung",
            "Siegerehrung inklusive",
            "Organisierter Turniermodus auf Wunsch inklusive",
          ],
          note: "Optionale Zusatzleistungen werden separat berechnet.",
        },
        weTakeCare: {
          label: "WE TAKE CARE OF IT",
          title: "Sie wünschen. Wir organisieren.",
          desc: "Individuelle Planung und Koordination Ihres FootPool-Events – besonders für grössere oder komplexere Veranstaltungen.",
          note: "Das Organisationshonorar umfasst die Planung und Koordination. Spielfelder, Personal, Transport und weitere operative Leistungen werden separat berechnet.",
        },
      },
      addonsTitle: "ZUSATZLEISTUNGEN",
      addons: [
        "Zusätzliche Spielstunde",
        "Zweites Spielfeld inkl. zusätzlichem Personal",
      ],
      outdoorTitle: "OUTDOOR-OPTIONEN",
      outdoor: [
        "Wetterschutz",
        "Heizung",
        "Kühlung",
        "Wetterschutz + Heizung oder Kühlung",
      ],
      inspiration: {
        title: "Machen Sie mehr aus Ihrem Event",
        body: "Catering, DJ, Moderation, Fotografie, Eventtechnik, zusätzliche Aktivitäten, Giveaways und individuelle Brandingmöglichkeiten – auf Anfrage.",
      },
      custom: {
        title: "Weitere Wünsche? Wir machen vieles möglich.",
        body: "Die aufgeführten Möglichkeiten sind nur eine Auswahl. Erzählen Sie uns von Ihrer Idee – wir prüfen die Umsetzung und erstellen Ihnen ein individuelles Angebot.",
      },
      founding: {
        kicker: "FOUNDING CLIENT SEASON",
        title: "Dezember 2026 bis Februar 2027",
        body1: "Wetterschutz inklusive Heizung für CHF 450 statt CHF 570.",
        body2:
          "Angebot gilt ausschliesslich für die Schweizer Founding Client Season und nur für diese Kombination. Regulärer Betrieb startet im März 2027.",
      },
      payment: {
        label: "Zahlungsbedingungen für Events:",
        text: "50 % bei Buchung, die restlichen 50 % innerhalb von 7 Tagen nach dem Event.",
      },
      brandingTitle: "Branding",
      brandingTag: "Brand experience",
      branded: {
        label: "BRANDED FOOTPOOL",
        title: "Interaktiv sichtbar.",
        durations: ["3 Monate", "6 Monate", "12 Monate"],
        items: [
          "Werbepräsenz auf einem FootPool-eigenen Spielfeld",
          "Einsatz bei geeigneten FootPool-Veranstaltungen und eigenen öffentlichen Auftritten",
          "Nachweis tatsächlich erfolgter Einsätze",
          "Gestaltung, Produktion und Anbringung des Brandings separat",
          "Keine garantierte Anzahl Einsätze oder Kontakte",
          "Keine exklusive Nutzung des Spielfelds durch den Werbekunden",
        ],
      },
      campaign: {
        label: "CAMPAIGN FOOTPOOL",
        title: "Menschen interaktiv erreichen.",
        desc: "Exklusive Miete eines modularen FootPool-Spielfelds für die eigene Kampagne.",
        rates: ["1–3 Tage, pro Tag", "1 Woche", "1 Monat"],
        items: [
          "Wochenmiete: 6 Nutzungstage, Rückgabe am 7. Tag.",
          "Monatsmiete: 30 Nutzungstage, Rückgabe am 31. Tag.",
          "Transport, Lieferung, Aufbau, Personal, Branding und weitere operative Leistungen werden separat angeboten.",
          "Verlängerungen nach Absprache.",
        ],
      },
      weTakeBrand: {
        label: "WE TAKE CARE OF IT",
        title: "Ihre Marke interaktiv erlebbar machen.",
        desc: "Individuelle Planung und Koordination einer FootPool-bezogenen Markenaktion.",
        note: "Das Organisationshonorar deckt Planung und Koordination ab. Spielfelder, Branding, Transport, Personal und weitere Leistungen werden separat berechnet.",
      },
    },
    faq: {
      kicker: "FAQ",
      title: "Häufig gestellte Fragen",
      intro:
        "Antworten auf die häufigsten Fragen zu FootPool, Events und Branding.",
      stillHave: "Haben Sie noch Fragen?",
      cta: "Fragen Sie uns",
      groups: [
        { label: "Allgemeines" },
        { label: "Events & Organisation" },
        { label: "Branding & Kampagnen" },
      ],
      items: [
        { g: 0, q: "Was ist FootPool?", a: "FootPool verbindet Fussball und Billard auf einem grossformatigen Spielfeld. Statt mit einem Queue werden die Bälle mit den Füssen gespielt. Das Ergebnis ist ein interaktives Erlebnis, das Bewegung, Geschicklichkeit und gemeinsame Unterhaltung verbindet." },
        { g: 0, q: "Für wen eignet sich FootPool?", a: "Für Unternehmen, Teams, Organisationen, Vereine, Schulen und Veranstalter. FootPool eignet sich sowohl für Firmenevents und Teambuilding als auch für Messen, Promotionen und interaktive Markenauftritte." },
        { g: 0, q: "Braucht man für FootPool eine besondere körperliche Fitness?", a: "Nein. FootPool erfordert weder besondere Kondition noch sportliche Vorkenntnisse. Im Vordergrund stehen Geschicklichkeit, Präzision und der gemeinsame Spass. Jeder spielt in seinem eigenen Tempo." },
        { g: 0, q: "Wie viele Personen können gleichzeitig spielen?", a: "Üblicherweise spielen ein oder zwei Personen pro Team gegeneinander. Durch wechselnde Partien können auch grössere Gruppen teilnehmen. Unsere Eventangebote sind auf unterschiedliche Gruppengrössen ausgelegt." },
        { g: 0, q: "Wie heisst dieses Spiel noch?", a: "FootPool wird je nach Region auch Fussballbillard, Fußballbillard, Poolball, Pool Ball, Soccer Billard oder Football Billiards genannt. Gemeint ist immer dasselbe Spielprinzip: Billard mit den Füssen auf einem grossformatigen Spielfeld – nicht zu verwechseln mit Tischfussball." },
        { g: 1, q: "Was ist der Unterschied zwischen TRY IT und MAKE IT YOURS?", a: "TRY IT bietet ein betreutes FootPool-Erlebnis für bis zu zwölf Personen mit zwei Stunden Spielzeit. MAKE IT YOURS bietet bis zu 24 Personen vier Stunden Spielzeit, eine Siegerehrung und auf Wunsch einen organisierten Turniermodus. Das Erlebnis lässt sich ausserdem mit zusätzlichen Leistungen wie längerer Spielzeit, einem zweiten Spielfeld, Moderation, Wetterschutz sowie Heizung oder Kühlung individuell gestalten. Diese Zusatzleistungen sind separat buchbar." },
        { g: 1, q: "Was beinhaltet WE TAKE CARE OF IT?", a: "Wir übernehmen die individuelle Planung und Koordination Ihres FootPool-Events. Das Angebot richtet sich insbesondere an grössere oder komplexere Veranstaltungen. Die Organisationsgebühr sowie benötigte Spielfelder und Zusatzleistungen werden separat ausgewiesen." },
        { g: 1, q: "Können wir FootPool drinnen und draussen einsetzen?", a: "Ja. Voraussetzung sind ausreichend Platz und ein geeigneter, ebener Untergrund. Wir prüfen gemeinsam, ob der gewünschte Veranstaltungsort geeignet ist." },
        { g: 1, q: "Wie viel Platz wird für FootPool benötigt?", a: "Für FootPool benötigen Sie eine freie Fläche von mindestens 10 × 4 Metern, damit genügend Platz zum Spielen vorhanden ist. FootPool kann sowohl drinnen als auch draussen gespielt werden." },
        { g: 1, q: "Was passiert bei schlechtem Wetter?", a: "Für Outdoor-Veranstaltungen bieten wir optional Wetterschutz sowie Heiz- oder Kühlmöglichkeiten an. Während unserer Founding Client Season von Dezember 2026 bis Februar 2027 gibt es in der Schweiz die Kombination aus Wetterschutz und Heizung zum Sonderpreis von CHF 450." },
        { g: 1, q: "Sind Transport, Aufbau und Betreuung im Preis enthalten?", a: "Bei TRY IT und MAKE IT YOURS sind Lieferung, Aufbau, Abbau und Betreuung Bestandteil des Angebots. Bei individuellen Events und Branding-Kampagnen richtet sich der Leistungsumfang nach dem vereinbarten Angebot. Anfahrtskosten werden separat berechnet." },
        { g: 2, q: "Wie schafft FootPool einen Mehrwert für Branding und Marketing?", a: "FootPool macht Marken interaktiv erlebbar. Statt Werbung nur anzusehen, werden Menschen selbst aktiv, spielen und kommen miteinander ins Gespräch. So entstehen Aufmerksamkeit, Interaktion und längere Verweildauer – und damit Gelegenheiten für persönliche Begegnungen und Gespräche. Ob Messe, Promotion, Roadshow oder öffentliche Kampagne: FootPool schafft Raum für Gespräche." },
        { g: 2, q: "Was ist BRANDED FOOTPOOL?", a: "Sie buchen Werbefläche auf einem unserer FootPool-Spielfelder. Das Spielfeld bleibt unser Eigentum und wird bei geeigneten FootPool-Veranstaltungen und eigenen öffentlichen Auftritten eingesetzt. Eine bestimmte Anzahl Einsätze oder Kontakte wird nicht garantiert." },
        { g: 2, q: "Was ist CAMPAIGN FOOTPOOL?", a: "Mit CAMPAIGN FOOTPOOL stellen wir Ihnen ein FootPool-Spielfeld exklusiv für Ihre Kampagne zur Verfügung. Die Mietdauer kann einzelne Tage, eine Woche oder einen Monat umfassen. Transport, Betreuung und Branding werden nach Bedarf separat angeboten." },
        { g: 2, q: "Können wir das Spielfeld individuell gestalten lassen?", a: "Ja. Je nach Angebot können geeignete Werbeflächen und Gestaltungselemente individuell gebrandet werden. Gestaltung, Produktion und Umsetzung werden separat vereinbart." },
        { g: 2, q: "Können wir eine komplette Branding-Aktion organisieren lassen?", a: "Ja. Mit WE TAKE CARE OF IT unterstützen wir Sie bei der Planung und Organisation Ihrer FootPool-Kampagne. Der konkrete Leistungsumfang wird gemeinsam festgelegt." },
      ],
    },
    contact: {
      kicker: "KONTAKT",
      title: "Planen wir Ihren nächsten Event.",
      subtitle:
        "Ob Firmenanlass, Vereinsfest, Schule oder öffentliche Veranstaltung – wir beraten Sie persönlich und erstellen Ihnen eine unverbindliche Offerte.",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      locationLabel: "Standort",
      locationValue: "9468 Sax, Schweiz",
      formIntro:
        "Senden Sie uns einige Informationen zu Ihrem Anlass. Wir melden uns mit einer passenden Lösung.",
      requiredNote: "* Pflichtfelder",
      sections: {
        inquiry: "Ihre Anfrage",
        details: "Kontaktangaben",
        address: "Kontaktadresse",
        eventLocation: "Veranstaltungsort",
        additional: "Angaben zum Anlass",
      },
      interestLabel: "Interessiert an",
      interests: {
        events: "Events / Teambuilding",
        branding: "Branding / Marketing",
        general: "Allgemeine Anfrage",
      },
      firstName: "Vorname",
      lastName: "Nachname",
      company: "Unternehmen / Organisation",
      optional: "Optional",
      email: "E-Mail-Adresse",
      emailPlaceholder: "name@beispiel.ch",
      phone: "Telefonnummer",
      phonePlaceholder: "+41 …",
      street: "Strasse und Hausnummer",
      zip: "PLZ",
      city: "Ort",
      country: "Land",
      countries: { CH: "Schweiz", DE: "Deutschland", AT: "Österreich", other: "Anderes Land" },
      countryOther: "Welches Land?",
      eventLoc: {
        same: "Gleich wie Kontaktadresse",
        different: "Abweichender Veranstaltungsort",
        unknown: "Veranstaltungsort noch nicht bekannt",
      },
      venue: "Location / Venue",
      expectedRegion: "Erwartete Stadt / Region",
      eventType: "Art der Veranstaltung",
      eventTypes: {
        corporate: "Firmenanlass / Teamevent",
        club: "Vereinsanlass",
        private: "Private Feier",
        public: "Öffentliche Veranstaltung / Festival",
        school: "Schule / Bildung",
        other: "Sonstiges",
      },
      selectPlaceholder: "Bitte auswählen",
      dateMode: "Wunschdatum / Zeitraum",
      usagePeriod: "Gewünschter Einsatzzeitraum",
      fixed: "Fester Termin",
      flexible: "Flexibler Zeitraum",
      startDate: "Startdatum",
      endDate: "Enddatum",
      oneDayHint: "Für einen eintägigen Anlass genügt das Startdatum.",
      flexiblePeriod: "Zeitraum",
      flexiblePlaceholder: "z. B. Mai 2027, bevorzugt Freitag oder Samstag",
      participants: "Ungefähre Teilnehmerzahl",
      participantsHint: "Eine Schätzung genügt.",
      participantsPlaceholder: "z. B. 30",
      expectedParticipants: "Erwartete Teilnehmende / Besuchende",
      message: "Nachricht / besondere Wünsche",
      messagePlaceholder: "Was sollten wir über Ihren Anlass wissen?",
      submit: "Unverbindliche Anfrage senden",
      submitting: "Wird gesendet…",
      success:
        "Vielen Dank! Ihre Anfrage wurde gespeichert. Wir melden uns bei Ihnen.",
      error: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
      errors: {
        required: "Pflichtfeld",
        emailInvalid: "Bitte eine gültige E-Mail-Adresse angeben.",
        endBeforeStart: "Das Enddatum darf nicht vor dem Startdatum liegen.",
        participantsInvalid: "Bitte eine positive ganze Zahl angeben.",
      },
      privacyNoticePre:
        "Die Angaben werden zur Bearbeitung Ihrer Anfrage verwendet. Weitere Informationen finden Sie in der",
      privacyNoticeLink: "Datenschutzerklärung",
    },
    footer: {
      tagline:
        "FootPool macht aus Firmenevents gemeinsame Erlebnisse und aus Markenauftritten interaktive Begegnungen.",
      location: "9468 Sax, Schweiz",
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      links: [
        { href: "#home", label: "Start" },
        { href: "#events", label: "Events" },
        { href: "#branding", label: "Branding" },
        { href: "#pricing", label: "Preise" },
        { href: "#faq", label: "FAQ" },
        { href: "#contact", label: "Kontakt" },
      ],
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      privacy: "Datenschutz",
    },
    legal: {
      closeAria: "Schliessen",
      dateLabel: "Stand:",
      impressum: {
        title: "Impressum",
        note:
          "Die Angaben erfolgen gemäss den geltenden rechtlichen Anforderungen für Webauftritte in der Schweiz. Für Inhalte externer verlinkter Seiten wird keine Haftung übernommen.",
      },
      privacy: {
        title: "Datenschutzerklärung",
        stand: "Stand: 16. Oktober 2026",
        sections: [
          {
            h: "Verantwortlich für FootPool Events",
            paras: [
              "Petar Strajnic – FootPool Events\nWinggel 13\n9468 Sax, Schweiz\nE-Mail: info@footpoolevents.ch",
            ],
          },
          {
            h: "Kontakt und Anfragen",
            paras: [
              "Wenn Sie uns kontaktieren, bearbeiten wir Ihre Angaben zur Beantwortung Ihrer Anfrage, zur Erstellung einer Offerte und gegebenenfalls zur Vorbereitung und Abwicklung Ihres Auftrags.",
              "Dazu gehören Ihre Kontakt- und Adressdaten, Angaben zum Anlass und Ihre Nachricht. Bei Formularanfragen werden zusätzlich eine Anfragenummer, der Eingangszeitpunkt und die gewählte Sprache gespeichert.",
              "Die Speicherung erfolgt auf unserer Hosting-Plattform Emergent. Benachrichtigungen und Eingangsbestätigungen werden über den eingebundenen E-Mail-Dienst Resend versendet. Unser E-Mail-Postfach wird bei Hosttech betrieben.",
              "Wir geben Ihre Anfragedaten nicht für Werbung anderer Unternehmen weiter. Eine Nutzung durch andere Unternehmensteile des Eigentümers findet derzeit nicht statt.",
              "Soweit die DSGVO anwendbar ist, bearbeiten wir diese Daten für vorvertragliche Massnahmen und zur Vertragserfüllung gemäss Art. 6 Abs. 1 lit. b DSGVO. Sonstige Korrespondenz bearbeiten wir aufgrund unseres berechtigten Interesses an der Beantwortung von Anfragen gemäss Art. 6 Abs. 1 lit. f DSGVO.",
            ],
          },
          {
            h: "Websitebetrieb",
            paras: [
              "Die Website wird bei Emergent gehostet und über Cloudflare ausgeliefert. Dabei werden technische Verbindungsdaten wie IP-Adresse, Browserinformationen und Zugriffszeitpunkt zur Bereitstellung und Absicherung der Website verarbeitet. Hierfür können technisch notwendige Cookies eingesetzt werden.",
              "Soweit die DSGVO anwendbar ist, erfolgt dies aufgrund unseres berechtigten Interesses an einem sicheren und zuverlässigen Websitebetrieb gemäss Art. 6 Abs. 1 lit. f DSGVO.",
              "Ihre Sprachauswahl wird im lokalen Speicher Ihres Browsers gespeichert. Sie können diese Einstellung durch Löschen der Website-Daten in Ihrem Browser entfernen.",
            ],
          },
          {
            h: "Externe Schriftarten",
            paras: [
              "Die Website lädt Schriftarten über Google Fonts. Dabei werden Ihre IP-Adresse und technische Anfragedaten an Google übermittelt. Eine Verarbeitung in den USA ist möglich.",
            ],
            links: [
              { label: "Weitere Informationen", url: "https://policies.google.com/privacy" },
            ],
          },
          {
            h: "Analyse durch die Hosting-Plattform",
            paras: [
              "Emergent bindet PostHog ein. Dabei werden Seitenaufrufe und Interaktionen erfasst; ausserdem ist eine Sitzungsaufzeichnung aktiviert. Für Eingabefelder ist eine Maskierung vorgesehen. Das Kontaktformular ist zusätzlich mit einer Ausschlusskennzeichnung versehen.",
              "Die Einbindung wird von Emergent gesteuert. Über das Emergent-Dashboard stehen FootPool Events zusammengefasste Besucherstatistiken zur Verfügung, beispielsweise zu Seitenaufrufen, Zugriffsquellen, Ländern und Gerätetypen. Diese dienen der Beurteilung der Nutzung und der Verbesserung unseres Webauftritts. Ein direkter Zugang zum PostHog-Projekt oder zu einzelnen Sitzungsaufzeichnungen ist damit nicht verbunden. Die bislang untersuchte PostHog-Einbindung übermittelt Analysedaten in die USA.",
              "Informationen zur Datenverarbeitung der Anbieter und Kontaktmöglichkeiten für entsprechende Fragen finden Sie hier:",
            ],
            links: [
              { label: "Emergent Datenschutz", url: "https://www.app.emergentagent.sh/privacy-policy" },
              { label: "PostHog Datenschutz", url: "https://posthog.com/privacy" },
            ],
          },
          {
            h: "Dienstleister und Auslandverarbeitung",
            paras: [
              "Für den Websitebetrieb und die Kommunikation werden Emergent, Cloudflare, Resend und Hosttech eingesetzt. Durch die beschriebenen Einbindungen erhalten auch Google und PostHog Daten.",
              "Emergent nennt die USA, die EU und Indien als Verarbeitungsorte seiner Dienste. Resend speichert E-Mail-Inhalte und Versanddaten in den USA. Unser Hosttech-Postfach wird im Rahmen des Schweizer Webhostings in der Schweiz gespeichert.",
              "Resend sieht für internationale Datenübermittlungen Standardvertragsklauseln mit Anpassungen für die Schweiz vor. PostHog nennt Standardvertragsklauseln und die Teilnahme am Swiss–U.S. sowie EU–U.S. Data Privacy Framework.",
              "Weitere Anbieterinformationen:",
            ],
            links: [
              { label: "Emergent Datenverarbeitungsvertrag", url: "https://app.emergent.sh/dpa" },
              { label: "Emergent Unterauftragnehmer", url: "https://app.emergent.sh/subprocessors" },
              { label: "Cloudflare Datenschutz", url: "https://www.cloudflare.com/privacypolicy/" },
              { label: "Resend Datenschutz und Datenübermittlungen", url: "https://resend.com/security/gdpr" },
              { label: "Hosttech Datenschutz", url: "https://www.hosttech.ch/datenschutz/" },
            ],
          },
          {
            h: "Aufbewahrung",
            paras: [
              "Wir bewahren Ihre Anfragedaten und Korrespondenz so lange auf, wie sie für die Bearbeitung, Auftragsabwicklung oder die Wahrung rechtlicher Ansprüche erforderlich sind. Gesetzliche Aufbewahrungspflichten bleiben vorbehalten. Anschliessend werden die Daten gelöscht oder anonymisiert.",
              "Für die von Emergent gesteuerte Analyse gelten die Aufbewahrungsregelungen der beteiligten Anbieter.",
            ],
          },
          {
            h: "Ihre Rechte",
            paras: [
              "Nach Massgabe des anwendbaren Datenschutzrechts können Sie Auskunft, Berichtigung oder Löschung Ihrer Personendaten verlangen. Soweit anwendbar, haben Sie ausserdem Rechte auf Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Eine erteilte Einwilligung können Sie jederzeit für die Zukunft widerrufen.",
              "Kontakt: info@footpoolevents.ch",
              "Sie können sich auch an die zuständige Datenschutzaufsichtsbehörde wenden: in der Schweiz an den EDÖB, in Deutschland an die zuständige Landesdatenschutzbehörde und in Österreich an die Datenschutzbehörde.",
            ],
          },
        ],
      },
    },
    seo: {
      htmlLang: "de",
      ogLocale: "de_CH",
      title: "FootPool Events – Fussballbillard & Poolball für Firmenevents",
      description:
        "FootPool – auch Fussballbillard oder Poolball genannt: Billard mit den Füssen als betreuter Firmenevent, Teamevent oder interaktive Markenaktivierung. Mobil, aus der Ostschweiz schweizweit.",
      ogTitle: "FootPool Events — Fussball trifft Billard. Menschen treffen Marken.",
      ogDescription:
        "Betreute Firmenevents, Teamevents und interaktive Markenaktivierung mit FootPool: Fussball und Billard auf einem grossformatigen Spielfeld – mobil in der ganzen Schweiz.",
      twitterTitle: "FootPool Events – Fussballbillard für Firmenevents & Branding",
      twitterDescription:
        "Betreute Firmenevents und interaktive Markenauftritte mit FootPool, aus der Ostschweiz schweizweit.",
      keywords:
        "footpool, fussballbillard, poolball, fußballbillard, soccer billard, fussball billard mieten, firmenevent, firmenanlass, teambuilding, teamevent, betriebsausflug, markenaktivierung, messeattraktion, ostschweiz, st. gallen, rheintal, werdenberg, schweiz",
      ogImageAlt: "FootPool-Spielfeld bei einem Firmenevent am Abend",
    },
  },

  /* ============================== FRANÇAIS ============================== */
  fr: {
    nav: {
      home: "Accueil",
      events: "Événements",
      branding: "Branding",
      how: "Comment ça marche",
      pricing: "Tarifs",
      faq: "FAQ",
      contact: "Contact",
      cta: "Demander un devis gratuit",
    },
    hero: {
      badge: "⚽ Le football rencontre le billard.",
      title1: "Le football rencontre le billard.",
      title2: "Les personnes rencontrent les marques.",
      subtitle:
        "FootPool transforme les événements d'entreprise en expériences partagées et les apparitions de marque en rencontres interactives.",
      inOut: "Le plaisir de jouer, à l'intérieur comme à l'extérieur.",
      cta1: "Découvrir les événements",
      cta2: "Découvrir le branding",
      cta1Href: "#events",
      cta2Href: "#branding",
      imgAlt:
        "Invités d'un événement d'entreprise autour d'un terrain FootPool au coucher du soleil",
    },
    events: {
      kicker: "ÉVÉNEMENTS",
      title: "Des événements qui rassemblent.",
      subtitle:
        "Team building, fête d'entreprise, sortie d'équipe, fête d'été ou fête de Noël : FootPool allie compétition ludique et expériences partagées. Participer, rire ensemble et renforcer l'esprit d'équipe – sans aucun prérequis sportif.",
      spaceLine: "Espace libre nécessaire : au minimum 10 × 4 mètres.",
      ctaLabel: "Voir les tarifs événements",
      ctaHref: "#pricing-events",
      collageAlts: [
        "Invités lors d'un événement d'entreprise FootPool en soirée",
        "Amis jouant au FootPool lors d'une fête privée au bord du lac",
        "Équipe célébrant un point lors d'un événement FootPool en ville",
      ],
      cards: [
        {
          label: "TRY IT",
          title: "Pour simplement essayer.",
          items: [
            "Jusqu'à 12 personnes",
            "2 heures",
            "1 terrain de jeu",
            "Livraison, montage et démontage",
            "2 collaborateurs FootPool",
            "Introduction et accompagnement",
          ],
        },
        {
          label: "MAKE IT YOURS",
          title: "Votre événement. Votre expérience.",
          items: [
            "Jusqu'à 24 personnes",
            "4 heures",
            "1 terrain de jeu",
            "Livraison, montage et démontage",
            "Au moins 2 collaborateurs FootPool",
            "Introduction et accompagnement",
            "Remise des prix incluse",
            "Mode tournoi organisé sur demande inclus",
            "Extensible individuellement avec des prestations supplémentaires réservables séparément",
          ],
        },
        {
          label: "WE TAKE CARE OF IT",
          title: "Vous souhaitez. Nous organisons.",
          items: [
            "Planification et coordination individuelles",
            "Particulièrement pour les événements plus grands ou complexes",
            "Coordination personnelle des prestations",
            "Frais d'organisation et prestations opérationnelles calculés séparément",
          ],
        },
      ],
    },
    branding: {
      kicker: "BRANDING",
      title: "Des marques que les gens vivent.",
      subtitle:
        "FootPool transforme les apparitions de marque en expériences interactives. Les gens deviennent actifs, restent plus longtemps et engagent la conversation. Animation de salon, promotion, roadshow ou action en centre commercial : nous créons un espace pour les échanges.",
      ctaLabel: "Voir les tarifs branding",
      ctaHref: "#pricing-branding",
      collageAlts: [
        "Terrain FootPool avec branding d'entreprise personnalisé",
        "Partie de FootPool vue depuis une poche du terrain",
      ],
      cards: [
        {
          label: "BRANDED FOOTPOOL",
          title: "Visible de manière interactive.",
          items: [
            "Présence publicitaire sur un terrain appartenant à FootPool",
            "Utilisation lors d'événements FootPool appropriés et d'apparitions publiques propres",
            "Durées de 3, 6 ou 12 mois",
            "Preuve des utilisations effectivement réalisées",
            "Aucune portée ni nombre d'utilisations garantis",
            "Aucune utilisation exclusive par le client publicitaire",
          ],
        },
        {
          label: "CAMPAIGN FOOTPOOL",
          title: "Toucher les gens de manière interactive.",
          items: [
            "Mise à disposition exclusive d'un terrain FootPool modulaire pour votre propre campagne",
            "Location à la journée, à la semaine ou au mois",
            "Idéal pour salons, promotions, roadshows et actions de marque",
            "Transport, personnel, branding et prestations supplémentaires réservables séparément",
          ],
        },
        {
          label: "WE TAKE CARE OF IT",
          title: "Rendre votre marque interactive.",
          items: [
            "Planification et coordination individuelles d'une action de marque liée à FootPool",
            "Coordination du terrain, du branding et du déroulement",
            "Frais d'organisation ; prestations opérationnelles séparées",
          ],
        },
      ],
    },
    how: {
      kicker: "3 étapes simples",
      title: "De l'idée à l'événement — en un clin d'œil.",
      steps: [
        { n: "01", t: "Réservez", d: "Choisissez la date et le lieu de votre événement. Après votre demande, nous nous occupons du reste." },
        { n: "02", t: "Nous installons", d: "Notre équipe arrive à temps et installe le terrain FootPool de manière professionnelle pour votre événement." },
        { n: "03", t: "Jouez", d: "À vous de jouer, de vibrer et de vivre ensemble des moments inoubliables." },
      ],
      imgAlt: "Terrain FootPool blanc installé dans un espace événementiel lumineux",
    },
    features: {
      kicker: "POURQUOI FOOTPOOL ?",
      title: "Bien plus qu'un jeu.",
      subtitle:
        "FootPool rassemble les gens, les met en mouvement et fait de chaque événement une expérience particulière.",
      items: [
        { t: "Accompagnement professionnel", d: "De la première demande à la réussite de l'événement, nous vous accompagnons personnellement." },
        { t: "Organisation simplifiée", d: "Avec TRY IT et MAKE IT YOURS, la livraison, le montage et le démontage sont inclus (déplacement facturé séparément). Pour les campagnes et les missions d'organisation, nous proposons transport et prestations opérationnelles séparément." },
        { t: "Du plaisir pour tous", d: "Aucun prérequis — il suffit de jouer et de profiter." },
        { t: "Disponible dans toute la Suisse", d: "Nous apportons FootPool comme jeu d'événement mobile directement sur le lieu de votre événement – depuis notre région d'origine en Suisse orientale (Saint-Gall, vallée du Rhin, Werdenberg), dans toute la Suisse." },
      ],
      imgAlt: "Équipe célébrant lors d'un événement FootPool en ville",
    },
    occasions: {
      kicker: "PARFAIT POUR",
      title: "L'animation idéale pour chaque occasion",
      subtitle:
        "Événement d'entreprise, école, club ou fête publique — FootPool rassemble et apporte mouvement, esprit d'équipe et beaucoup de plaisir.",
      cards: {
        firmenevents: {
          t: "Événements d'entreprise & team building",
          d: "Fêtes d'entreprise, kick-offs, after-work et événements d'équipe.",
          alt: "Terrain FootPool blanc installé dans un bureau moderne avec baies vitrées",
        },
        branding: {
          t: "Branding & Marketing",
          d: "Apparitions de marque, salons et présence publicitaire interactive avec FootPool.",
          alt: "Terrain FootPool avec surface de jeu brandée personnalisée",
        },
        vereine: {
          t: "Clubs & associations",
          d: "Fêtes de club, fins de saison et anniversaires.",
          alt: "Amis jouant au FootPool lors d'une fête en plein air au coucher du soleil",
        },
        gemeinden: {
          t: "Communes & événements publics",
          d: "Fêtes de ville et de village, événements de jeunesse et manifestations publiques.",
          alt: "Enfants jouant sur un terrain FootPool lors d'une fête publique en plein air",
        },
        messen: {
          t: "Salons & promotions",
          d: "Un aimant à public interactif pour salons, promotions et journées spéciales.",
          alt: "Impressions d'événements FootPool avec branding lors de manifestations publiques",
        },
        schulen: {
          t: "Écoles",
          d: "Journées sportives, camps scolaires et événements scolaires spéciaux.",
          alt: "Écoliers jouant au FootPool avec des balles numérotées",
        },
      },
    },
    gallery: {
      kicker: "Galerie",
      title: "L'énergie FootPool en images.",
      alts: [
        "Terrain FootPool brandé installé dans un bureau",
        "Invités autour du terrain FootPool dans une salle en briques",
        "Équipe célébrant lors d'un événement FootPool en ville",
        "Invités lors d'une soirée d'entreprise FootPool",
      ],
    },
    aiNote: {
      title: "À PROPOS DE NOS IMAGES",
      body:
        "FootPool Events se lance en 2026. Certaines images présentées sur ce site ont donc été créées ou retravaillées avec l'IA afin d'illustrer des événements et situations FootPool possibles. Dès que nos premières manifestations auront lieu, elles seront progressivement remplacées par des photos d'événements FootPool réels.\nL'offre, l'équipement et les prestations indiquées sont naturellement indépendants de ces images et bien réels.",
    },
    pricing: {
      kicker: "TRANSPARENT & INDIVIDUEL",
      title: "Tarifs & formules",
      subtitle:
        "Tous les prix s'entendent hors TVA. Les prestations supplémentaires individuelles et les frais de déplacement sont facturés séparément.",
      countryAria: "Choisir le pays",
      countries: { CH: "Suisse (CHF)", DE: "Allemagne (€)", AT: "Autriche (€)" },
      from: "dès",
      orgFrom: "Frais d'organisation dès",
      onRequest: "Prix sur demande",
      perMonth: "/ mois",
      eventsTitle: "Événements",
      eventsTag: "Employee experience",
      offers: {
        tryIt: {
          label: "TRY IT",
          title: "Pour simplement essayer",
          items: [
            "Jusqu'à 12 personnes",
            "2 heures de jeu",
            "1 terrain FootPool",
            "Livraison, montage et démontage",
            "2 collaborateurs FootPool",
            "Introduction et accompagnement",
          ],
        },
        makeItYours: {
          label: "MAKE IT YOURS",
          title: "Votre événement. Votre expérience.",
          items: [
            "Jusqu'à 24 personnes",
            "4 heures de jeu",
            "1 terrain FootPool",
            "Livraison, montage et démontage",
            "Au moins 2 collaborateurs FootPool",
            "Introduction et accompagnement",
            "Remise des prix incluse",
            "Mode tournoi organisé sur demande inclus",
          ],
          note: "Les prestations supplémentaires optionnelles sont facturées séparément.",
        },
        weTakeCare: {
          label: "WE TAKE CARE OF IT",
          title: "Vous souhaitez. Nous organisons.",
          desc: "Planification et coordination individuelles de votre événement FootPool – en particulier pour les manifestations plus grandes ou complexes.",
          note: "Les frais d'organisation comprennent la planification et la coordination. Terrains, personnel, transport et autres prestations opérationnelles sont facturés séparément.",
        },
      },
      addonsTitle: "PRESTATIONS SUPPLÉMENTAIRES",
      addons: [
        "Heure de jeu supplémentaire",
        "Deuxième terrain, personnel supplémentaire inclus",
      ],
      outdoorTitle: "OPTIONS EXTÉRIEURES",
      outdoor: [
        "Protection contre les intempéries",
        "Chauffage",
        "Rafraîchissement",
        "Protection + chauffage ou rafraîchissement",
      ],
      inspiration: {
        title: "Tirez le meilleur de votre événement",
        body: "Restauration, DJ, animation, photographie, technique événementielle, activités supplémentaires, giveaways et possibilités de branding personnalisées – sur demande.",
      },
      custom: {
        title: "D'autres souhaits ? Nous rendons beaucoup de choses possibles.",
        body: "Les possibilités mentionnées ne sont qu'un aperçu. Parlez-nous de votre idée – nous vérifions sa faisabilité et vous préparons une offre individuelle.",
      },
      founding: {
        kicker: "FOUNDING CLIENT SEASON",
        title: "Décembre 2026 à février 2027",
        body1: "Protection contre les intempéries, chauffage inclus, pour CHF 450 au lieu de CHF 570.",
        body2:
          "Offre valable exclusivement pour la Founding Client Season suisse et uniquement pour cette combinaison. L'activité régulière démarre en mars 2027.",
      },
      payment: {
        label: "Conditions de paiement pour les événements :",
        text: "50 % à la réservation, les 50 % restants dans les 7 jours suivant l'événement.",
      },
      brandingTitle: "Branding",
      brandingTag: "Brand experience",
      branded: {
        label: "BRANDED FOOTPOOL",
        title: "Visible de manière interactive.",
        durations: ["3 mois", "6 mois", "12 mois"],
        items: [
          "Présence publicitaire sur un terrain appartenant à FootPool",
          "Utilisation lors d'événements FootPool appropriés et d'apparitions publiques propres",
          "Preuve des utilisations effectivement réalisées",
          "Conception, production et pose du branding en sus",
          "Aucun nombre garanti d'utilisations ou de contacts",
          "Aucune utilisation exclusive du terrain par le client publicitaire",
        ],
      },
      campaign: {
        label: "CAMPAIGN FOOTPOOL",
        title: "Toucher les gens de manière interactive.",
        desc: "Location exclusive d'un terrain FootPool modulaire pour votre propre campagne.",
        rates: ["1–3 jours, par jour", "1 semaine", "1 mois"],
        items: [
          "Location à la semaine : 6 jours d'utilisation, retour le 7e jour.",
          "Location au mois : 30 jours d'utilisation, retour le 31e jour.",
          "Transport, livraison, montage, personnel, branding et autres prestations opérationnelles proposés séparément.",
          "Prolongations possibles sur demande.",
        ],
      },
      weTakeBrand: {
        label: "WE TAKE CARE OF IT",
        title: "Rendre votre marque interactive.",
        desc: "Planification et coordination individuelles d'une action de marque liée à FootPool.",
        note: "Les frais d'organisation couvrent la planification et la coordination. Terrains, branding, transport, personnel et autres prestations sont facturés séparément.",
      },
    },
    faq: {
      kicker: "FAQ",
      title: "Questions fréquentes",
      intro:
        "Réponses aux questions les plus fréquentes sur FootPool, les événements et le branding.",
      stillHave: "Vous avez encore des questions ?",
      cta: "Contactez-nous",
      groups: [
        { label: "Général" },
        { label: "Événements & organisation" },
        { label: "Branding & campagnes" },
      ],
      items: [
        { g: 0, q: "Qu'est-ce que FootPool ?", a: "FootPool associe football et billard sur un terrain de grand format. Au lieu d'une queue de billard, les balles se jouent avec les pieds. Le résultat : une expérience interactive alliant mouvement, adresse et convivialité." },
        { g: 0, q: "À qui s'adresse FootPool ?", a: "Aux entreprises, équipes, organisations, clubs, écoles et organisateurs. FootPool convient aussi bien aux événements d'entreprise et au team building qu'aux salons, promotions et apparitions de marque interactives." },
        { g: 0, q: "Faut-il une condition physique particulière pour FootPool ?", a: "Non. FootPool n'exige ni condition particulière ni connaissances sportives. L'accent est mis sur l'adresse, la précision et le plaisir partagé. Chacun joue à son rythme." },
        { g: 0, q: "Combien de personnes peuvent jouer en même temps ?", a: "En général, une ou deux personnes par équipe s'affrontent. Grâce à la rotation des parties, même les grands groupes peuvent participer. Nos offres événementielles sont conçues pour différentes tailles de groupes." },
        { g: 0, q: "Quels autres noms porte ce jeu ?", a: "Selon les régions, FootPool est aussi appelé footbillard, billard football, football billiards ou soccer billard. Le principe est toujours le même : du billard joué avec les pieds sur un terrain grand format – à ne pas confondre avec le baby-foot." },
        { g: 1, q: "Quelle est la différence entre TRY IT et MAKE IT YOURS ?", a: "TRY IT propose une expérience FootPool encadrée pour jusqu'à douze personnes avec deux heures de jeu. MAKE IT YOURS offre à jusqu'à 24 personnes quatre heures de jeu, une remise des prix et, sur demande, un mode tournoi organisé. L'expérience peut en outre être personnalisée avec des prestations supplémentaires telles qu'un temps de jeu prolongé, un deuxième terrain, une modération, une protection contre les intempéries ainsi que chauffage ou rafraîchissement. Ces prestations supplémentaires sont réservables séparément." },
        { g: 1, q: "Que comprend WE TAKE CARE OF IT ?", a: "Nous prenons en charge la planification et la coordination individuelles de votre événement FootPool. L'offre s'adresse en particulier aux manifestations plus grandes ou complexes. Les frais d'organisation ainsi que les terrains et prestations supplémentaires nécessaires sont indiqués séparément." },
        { g: 1, q: "Peut-on utiliser FootPool en intérieur et en extérieur ?", a: "Oui. Les conditions requises sont un espace suffisant et un sol approprié et plat. Nous vérifions ensemble si le lieu souhaité convient." },
        { g: 1, q: "Quel espace faut-il prévoir pour le FootPool ?", a: "Prévoyez un espace libre d'au moins 10 × 4 mètres afin de disposer de suffisamment de place pour jouer. Le FootPool se pratique aussi bien à l'intérieur qu'à l'extérieur." },
        { g: 1, q: "Que se passe-t-il en cas de mauvais temps ?", a: "Pour les événements en extérieur, nous proposons en option une protection contre les intempéries ainsi que des possibilités de chauffage ou de rafraîchissement. Pendant notre Founding Client Season, de décembre 2026 à février 2027, la combinaison protection contre les intempéries et chauffage est disponible en Suisse au prix spécial de CHF 450." },
        { g: 1, q: "Le transport, le montage et l'encadrement sont-ils inclus dans le prix ?", a: "Avec TRY IT et MAKE IT YOURS, la livraison, le montage, le démontage et l'encadrement font partie de l'offre. Pour les événements individuels et les campagnes de branding, l'étendue des prestations dépend de l'offre convenue. Les frais de déplacement sont calculés séparément." },
        { g: 2, q: "Comment FootPool crée-t-il une valeur ajoutée pour le branding et le marketing ?", a: "FootPool rend les marques interactives. Au lieu de simplement regarder une publicité, les gens deviennent actifs, jouent et échangent entre eux. Il en résulte de l'attention, de l'interaction et un temps de présence prolongé – autant d'occasions de rencontres et de conversations personnelles. Salon, promotion, roadshow ou campagne publique : FootPool crée un espace pour les échanges." },
        { g: 2, q: "Qu'est-ce que BRANDED FOOTPOOL ?", a: "Vous réservez une surface publicitaire sur l'un de nos terrains FootPool. Le terrain reste notre propriété et est utilisé lors d'événements FootPool appropriés et de nos propres apparitions publiques. Un nombre déterminé d'utilisations ou de contacts n'est pas garanti." },
        { g: 2, q: "Qu'est-ce que CAMPAIGN FOOTPOOL ?", a: "Avec CAMPAIGN FOOTPOOL, nous mettons un terrain FootPool à votre disposition en exclusivité pour votre campagne. La durée de location peut couvrir quelques jours, une semaine ou un mois. Transport, encadrement et branding sont proposés séparément selon les besoins." },
        { g: 2, q: "Peut-on personnaliser le terrain ?", a: "Oui. Selon l'offre, les surfaces publicitaires et éléments de conception appropriés peuvent être brandés individuellement. La conception, la production et la mise en œuvre sont convenues séparément." },
        { g: 2, q: "Peut-on faire organiser une action de branding complète ?", a: "Oui. Avec WE TAKE CARE OF IT, nous vous accompagnons dans la planification et l'organisation de votre campagne FootPool. L'étendue concrète des prestations est définie ensemble." },
      ],
    },
    contact: {
      kicker: "CONTACT",
      title: "Organisons ensemble votre prochain événement.",
      subtitle:
        "Événement d'entreprise, fête de club, école ou manifestation publique — nous vous conseillons personnellement et vous préparons une offre sans engagement.",
      emailLabel: "E-mail",
      phoneLabel: "Téléphone",
      locationLabel: "Lieu",
      locationValue: "9468 Sax, Suisse",
      formIntro:
        "Envoyez-nous quelques informations sur votre événement. Nous vous répondrons avec une proposition adaptée.",
      requiredNote: "* Champs obligatoires",
      sections: {
        inquiry: "Votre demande",
        details: "Coordonnées",
        address: "Adresse de contact",
        eventLocation: "Lieu de l'événement",
        additional: "Informations complémentaires",
      },
      interestLabel: "Intéressé par",
      interests: {
        events: "Événements / team building",
        branding: "Branding / marketing",
        general: "Demande générale",
      },
      firstName: "Prénom",
      lastName: "Nom",
      company: "Entreprise / organisation",
      optional: "Facultatif",
      email: "Adresse e-mail",
      emailPlaceholder: "nom@exemple.ch",
      phone: "Numéro de téléphone",
      phonePlaceholder: "+41 …",
      street: "Rue et numéro",
      zip: "NPA",
      city: "Localité",
      country: "Pays",
      countries: { CH: "Suisse", DE: "Allemagne", AT: "Autriche", other: "Autre pays" },
      countryOther: "Quel pays ?",
      eventLoc: {
        same: "Identique à l'adresse de contact",
        different: "Lieu de l'événement différent",
        unknown: "Lieu de l'événement pas encore connu",
      },
      venue: "Lieu / venue",
      expectedRegion: "Ville / région prévue",
      eventType: "Type d'événement",
      eventTypes: {
        corporate: "Événement d'entreprise / team building",
        club: "Fête de club",
        private: "Fête privée",
        public: "Manifestation publique / festival",
        school: "École / formation",
        other: "Autre",
      },
      selectPlaceholder: "Veuillez choisir",
      dateMode: "Date souhaitée / période",
      usagePeriod: "Période d'utilisation souhaitée",
      fixed: "Date fixe",
      flexible: "Période flexible",
      startDate: "Date de début",
      endDate: "Date de fin",
      oneDayHint: "Pour un événement d'une journée, la date de début suffit.",
      flexiblePeriod: "Période",
      flexiblePlaceholder: "p. ex. mai 2027, de préférence vendredi ou samedi",
      participants: "Nombre approximatif de participants",
      participantsHint: "Une estimation suffit.",
      participantsPlaceholder: "p. ex. 30",
      expectedParticipants: "Participants / visiteurs attendus",
      message: "Message / souhaits particuliers",
      messagePlaceholder: "Que devrions-nous savoir sur votre événement ?",
      submit: "Envoyer la demande sans engagement",
      submitting: "Envoi en cours…",
      success:
        "Merci beaucoup ! Votre demande a été enregistrée. Nous vous contacterons.",
      error: "La demande n'a pas pu être envoyée. Veuillez réessayer.",
      errors: {
        required: "Champ obligatoire",
        emailInvalid: "Veuillez indiquer une adresse e-mail valide.",
        endBeforeStart: "La date de fin ne peut pas précéder la date de début.",
        participantsInvalid: "Veuillez indiquer un nombre entier positif.",
      },
      privacyNoticePre:
        "Les informations sont utilisées pour traiter votre demande. Vous trouverez plus d'informations dans la",
      privacyNoticeLink: "déclaration de protection des données",
    },
    footer: {
      tagline:
        "FootPool transforme les événements d'entreprise en expériences partagées et les apparitions de marque en rencontres interactives.",
      location: "9468 Sax, Suisse",
      navTitle: "Navigation",
      contactTitle: "Contact",
      links: [
        { href: "#home", label: "Accueil" },
        { href: "#events", label: "Événements" },
        { href: "#branding", label: "Branding" },
        { href: "#pricing", label: "Tarifs" },
        { href: "#faq", label: "FAQ" },
        { href: "#contact", label: "Contact" },
      ],
      rights: "Tous droits réservés.",
      impressum: "Mentions légales",
      privacy: "Protection des données",
    },
    legal: {
      closeAria: "Fermer",
      dateLabel: "Version du :",
      impressum: {
        title: "Mentions légales",
        note:
          "Les informations sont fournies conformément aux exigences légales en vigueur pour les sites web en Suisse. Nous déclinons toute responsabilité quant au contenu des sites externes liés.",
      },
      privacy: {
        title: "Déclaration de protection des données",
        stand: "Version du : 16 octobre 2026",
        sections: [
          {
            h: "Responsable pour FootPool Events",
            paras: [
              "Petar Strajnic – FootPool Events\nWinggel 13\n9468 Sax, Suisse\nE-mail : info@footpoolevents.ch",
            ],
          },
          {
            h: "Contact et demandes",
            paras: [
              "Lorsque vous nous contactez, nous traitons vos informations pour répondre à votre demande, établir une offre et, le cas échéant, préparer et exécuter votre mandat.",
              "Cela comprend vos coordonnées et adresses, les informations sur votre événement ainsi que votre message. Pour les demandes via le formulaire, un numéro de demande, la date de réception et la langue choisie sont également enregistrés.",
              "Le stockage s'effectue sur notre plateforme d'hébergement Emergent. Les notifications et confirmations de réception sont envoyées via le service e-mail intégré Resend. Notre boîte e-mail est exploitée chez Hosttech.",
              "Nous ne transmettons pas les données de votre demande à des fins publicitaires d'autres entreprises. Aucune utilisation par d'autres entités appartenant au propriétaire n'a actuellement lieu.",
              "Dans la mesure où le RGPD est applicable, nous traitons ces données pour des mesures précontractuelles et pour l'exécution du contrat conformément à l'art. 6, par. 1, let. b RGPD. Toute autre correspondance est traitée sur la base de notre intérêt légitime à répondre aux demandes conformément à l'art. 6, par. 1, let. f RGPD.",
            ],
          },
          {
            h: "Exploitation du site web",
            paras: [
              "Le site web est hébergé chez Emergent et diffusé via Cloudflare. Des données techniques de connexion telles que l'adresse IP, les informations du navigateur et l'heure d'accès sont traitées pour fournir et sécuriser le site. Des cookies techniquement nécessaires peuvent être utilisés à cette fin.",
              "Dans la mesure où le RGPD est applicable, ce traitement repose sur notre intérêt légitime à une exploitation sûre et fiable du site web conformément à l'art. 6, par. 1, let. f RGPD.",
              "Votre choix de langue est enregistré dans le stockage local de votre navigateur. Vous pouvez supprimer ce réglage en effaçant les données du site dans votre navigateur.",
            ],
          },
          {
            h: "Polices de caractères externes",
            paras: [
              "Le site charge des polices via Google Fonts. Votre adresse IP et des données techniques de la requête sont transmises à Google. Un traitement aux États-Unis est possible.",
            ],
            links: [
              { label: "Plus d'informations", url: "https://policies.google.com/privacy" },
            ],
          },
          {
            h: "Analyse par la plateforme d'hébergement",
            paras: [
              "Emergent intègre PostHog. Les pages consultées et les interactions sont enregistrées ; un enregistrement des sessions est en outre activé. Un masquage est prévu pour les champs de saisie. Le formulaire de contact est en outre muni d'une marque d'exclusion.",
              "L'intégration est contrôlée par Emergent. Via le tableau de bord Emergent, FootPool Events dispose de statistiques de visite agrégées, par exemple sur les pages consultées, les sources de trafic, les pays et les types d'appareils. Elles servent à évaluer l'utilisation et à améliorer notre site web. Elles ne donnent pas d'accès direct au projet PostHog ni aux enregistrements de sessions individuelles. L'intégration PostHog examinée jusqu'à présent transmet des données d'analyse aux États-Unis.",
              "Vous trouverez des informations sur le traitement des données par les prestataires ainsi que des possibilités de contact pour vos questions ici :",
            ],
            links: [
              { label: "Emergent protection des données", url: "https://www.app.emergentagent.sh/privacy-policy" },
              { label: "PostHog protection des données", url: "https://posthog.com/privacy" },
            ],
          },
          {
            h: "Prestataires et traitement à l'étranger",
            paras: [
              "Emergent, Cloudflare, Resend et Hosttech sont utilisés pour l'exploitation du site et la communication. Par le biais des intégrations décrites, Google et PostHog reçoivent également des données.",
              "Emergent indique les États-Unis, l'UE et l'Inde comme lieux de traitement de ses services. Resend stocke les contenus des e-mails et les données d'envoi aux États-Unis. Notre boîte e-mail Hosttech est stockée en Suisse dans le cadre de l'hébergement web suisse.",
              "Resend prévoit des clauses contractuelles types avec des adaptations pour la Suisse pour les transferts internationaux de données. PostHog mentionne des clauses contractuelles types et la participation au Swiss–U.S. et EU–U.S. Data Privacy Framework.",
              "Autres informations des prestataires :",
            ],
            links: [
              { label: "Contrat de traitement des données Emergent", url: "https://app.emergent.sh/dpa" },
              { label: "Sous-traitants Emergent", url: "https://app.emergent.sh/subprocessors" },
              { label: "Cloudflare protection des données", url: "https://www.cloudflare.com/privacypolicy/" },
              { label: "Resend protection des données et transferts", url: "https://resend.com/security/gdpr" },
              { label: "Hosttech protection des données", url: "https://www.hosttech.ch/datenschutz/" },
            ],
          },
          {
            h: "Conservation",
            paras: [
              "Nous conservons les données de vos demandes et la correspondance aussi longtemps que nécessaire pour le traitement, l'exécution des mandats ou la sauvegarde de droits légaux. Les obligations légales de conservation restent réservées. Les données sont ensuite supprimées ou anonymisées.",
              "Pour l'analyse contrôlée par Emergent, les règles de conservation des prestataires concernés s'appliquent.",
            ],
          },
          {
            h: "Vos droits",
            paras: [
              "Conformément au droit applicable en matière de protection des données, vous pouvez demander l'accès, la rectification ou la suppression de vos données personnelles. Le cas échéant, vous disposez en outre de droits à la limitation du traitement, à la portabilité des données et d'opposition. Vous pouvez révoquer à tout moment un consentement donné avec effet pour l'avenir.",
              "Contact : info@footpoolevents.ch",
              "Vous pouvez également vous adresser à l'autorité de surveillance compétente en matière de protection des données : en Suisse au PFPDT, en Allemagne à l'autorité régionale compétente et en Autriche à l'autorité de protection des données.",
            ],
          },
        ],
      },
    },
    seo: {
      htmlLang: "fr",
      ogLocale: "fr_CH",
      title: "FootPool Events – Footbillard pour événements d'entreprise & branding",
      description:
        "FootPool – aussi appelé footbillard ou billard football : du billard avec les pieds pour vos événements d'entreprise, activités d'équipe et animations de marque. Mobile, depuis la Suisse orientale dans toute la Suisse.",
      ogTitle: "FootPool Events — Le football rencontre le billard. Les personnes rencontrent les marques.",
      ogDescription:
        "Événements d'entreprise encadrés, activités d'équipe et animations de marque interactives avec FootPool : football et billard sur un terrain grand format – mobile dans toute la Suisse.",
      twitterTitle: "FootPool Events – Footbillard pour événements & branding",
      twitterDescription:
        "Événements d'entreprise encadrés et animations de marque interactives avec FootPool, depuis la Suisse orientale dans toute la Suisse.",
      keywords:
        "footpool, footbillard, billard football, football billiards, location footbillard, événement d'entreprise, activité d'équipe, team building, animation de salon, animation centre commercial, suisse",
      ogImageAlt: "Terrain FootPool lors d'un événement d'entreprise en soirée",
    },
  },

  /* ============================== ITALIANO ============================== */
  it: {
    nav: {
      home: "Home",
      events: "Eventi",
      branding: "Branding",
      how: "Come funziona",
      pricing: "Prezzi",
      faq: "FAQ",
      contact: "Contatto",
      cta: "Richiedi un preventivo gratuito",
    },
    hero: {
      badge: "⚽ Il calcio incontra il biliardo.",
      title1: "Il calcio incontra il biliardo.",
      title2: "Le persone incontrano i marchi.",
      subtitle:
        "FootPool trasforma gli eventi aziendali in esperienze condivise e le apparizioni di marca in incontri interattivi.",
      inOut: "Divertimento al chiuso e all'aperto.",
      cta1: "Scopri gli eventi",
      cta2: "Scopri il branding",
      cta1Href: "#events",
      cta2Href: "#branding",
      imgAlt:
        "Ospiti di un evento aziendale attorno a un campo FootPool al tramonto",
    },
    events: {
      kicker: "EVENTI",
      title: "Eventi che uniscono le persone.",
      subtitle:
        "Team building, festa aziendale, gita aziendale, festa estiva o festa di Natale: FootPool unisce competizione giocosa ed esperienze condivise. Partecipare, ridere insieme e rafforzare lo spirito di squadra – senza alcun prerequisito sportivo.",
      spaceLine: "Spazio libero necessario: almeno 10 × 4 metri.",
      ctaLabel: "Vedi i prezzi eventi",
      ctaHref: "#pricing-events",
      collageAlts: [
        "Ospiti a un evento aziendale FootPool serale",
        "Amici che giocano a FootPool durante una festa privata in riva al lago",
        "Team che festeggia un punto durante un evento FootPool in città",
      ],
      cards: [
        {
          label: "TRY IT",
          title: "Per provare semplicemente.",
          items: [
            "Fino a 12 persone",
            "2 ore",
            "1 campo da gioco",
            "Consegna, montaggio e smontaggio",
            "2 collaboratori FootPool",
            "Introduzione e assistenza",
          ],
        },
        {
          label: "MAKE IT YOURS",
          title: "Il vostro evento. La vostra esperienza.",
          items: [
            "Fino a 24 persone",
            "4 ore",
            "1 campo da gioco",
            "Consegna, montaggio e smontaggio",
            "Almeno 2 collaboratori FootPool",
            "Introduzione e assistenza",
            "Premiazione inclusa",
            "Modalità torneo organizzata su richiesta inclusa",
            "Estendibile individualmente con prestazioni aggiuntive prenotabili separatamente",
          ],
        },
        {
          label: "WE TAKE CARE OF IT",
          title: "Voi desiderate. Noi organizziamo.",
          items: [
            "Pianificazione e coordinamento individuali",
            "Particolarmente per eventi più grandi o complessi",
            "Coordinamento personale delle prestazioni",
            "Onorario organizzativo e prestazioni operative calcolati separatamente",
          ],
        },
      ],
    },
    branding: {
      kicker: "BRANDING",
      title: "Marchi che le persone vivono.",
      subtitle:
        "FootPool trasforma le apparizioni di marca in esperienze interattive. Le persone diventano attive, restano più a lungo e iniziano a conversare. Animazione fieristica, promozione, roadshow o attività nei centri commerciali: creiamo spazio per il dialogo.",
      ctaLabel: "Vedi i prezzi branding",
      ctaHref: "#pricing-branding",
      collageAlts: [
        "Campo FootPool con branding aziendale personalizzato",
        "Partita di FootPool vista da una buca del campo",
      ],
      cards: [
        {
          label: "BRANDED FOOTPOOL",
          title: "Visibile in modo interattivo.",
          items: [
            "Presenza pubblicitaria su un campo di proprietà FootPool",
            "Utilizzo in occasione di eventi FootPool idonei e apparizioni pubbliche proprie",
            "Durate di 3, 6 o 12 mesi",
            "Prova degli utilizzi effettivamente avvenuti",
            "Nessuna copertura o numero di utilizzi garantiti",
            "Nessun uso esclusivo da parte del cliente pubblicitario",
          ],
        },
        {
          label: "CAMPAIGN FOOTPOOL",
          title: "Raggiungere le persone in modo interattivo.",
          items: [
            "Messa a disposizione esclusiva di un campo FootPool modulare per la propria campagna",
            "Noleggio giornaliero, settimanale o mensile",
            "Adatto per fiere, promozioni, roadshow e azioni di marca",
            "Trasporto, personale, branding e prestazioni aggiuntive prenotabili separatamente",
          ],
        },
        {
          label: "WE TAKE CARE OF IT",
          title: "Rendere il vostro marchio interattivo.",
          items: [
            "Pianificazione e coordinamento individuali di un'azione di marca legata a FootPool",
            "Coordinamento di campo, branding e svolgimento",
            "Onorario organizzativo; prestazioni operative separate",
          ],
        },
      ],
    },
    how: {
      kicker: "3 semplici passi",
      title: "Dall'idea all'evento — in un attimo.",
      steps: [
        { n: "01", t: "Prenotate", d: "Scegliete la data e il luogo dell'evento. Dopo la vostra richiesta, pensiamo noi al resto." },
        { n: "02", t: "Montiamo", d: "Il nostro team arriva puntualmente e allestisce il campo FootPool in modo professionale per il vostro evento." },
        { n: "03", t: "Giocare", d: "Ora si gioca, si fa il tifo e si vivono insieme momenti indimenticabili." },
      ],
      imgAlt: "Campo FootPool bianco allestito in uno spazio eventi luminoso",
    },
    features: {
      kicker: "PERCHÉ FOOTPOOL?",
      title: "Molto più di un gioco.",
      subtitle:
        "FootPool unisce le persone, le mette in movimento e rende ogni evento un'esperienza speciale.",
      items: [
        { t: "Assistenza professionale", d: "Dalla prima richiesta al successo dell'evento, vi accompagniamo personalmente." },
        { t: "Organizzazione semplice", d: "Con TRY IT e MAKE IT YOURS, consegna, montaggio e smontaggio sono inclusi (trasferta calcolata separatamente). Per le campagne e gli incarichi di organizzazione, offriamo trasporto e prestazioni operative separatamente." },
        { t: "Divertimento per tutti", d: "Nessun prerequisito — basta giocare e divertirsi." },
        { t: "Disponibile in tutta la Svizzera", d: "Portiamo FootPool come gioco per eventi mobile direttamente nel luogo del vostro evento – dalla nostra regione d'origine nella Svizzera orientale (San Gallo, Valle del Reno, Werdenberg), in tutta la Svizzera." },
      ],
      imgAlt: "Team che festeggia durante un evento FootPool in città",
    },
    occasions: {
      kicker: "PERFETTO PER",
      title: "L'animazione giusta per ogni occasione",
      subtitle:
        "Evento aziendale, scuola, associazione o festa pubblica — FootPool unisce le persone e porta movimento, spirito di squadra e tanto divertimento.",
      cards: {
        firmenevents: {
          t: "Eventi aziendali & team building",
          d: "Feste aziendali, kick-off, after-work ed eventi di squadra.",
          alt: "Campo FootPool bianco allestito in un ufficio moderno con finestre panoramiche",
        },
        branding: {
          t: "Branding & Marketing",
          d: "Apparizioni di marca, fiere e presenza pubblicitaria interattiva con FootPool.",
          alt: "Campo FootPool con superficie di gioco brandizzata personalizzata",
        },
        vereine: {
          t: "Associazioni & club",
          d: "Feste di associazione, fine stagione e anniversari.",
          alt: "Amici che giocano a FootPool durante una festa all'aperto al tramonto",
        },
        gemeinden: {
          t: "Comuni & eventi pubblici",
          d: "Feste di paese e di città, eventi giovanili e manifestazioni pubbliche.",
          alt: "Bambini che giocano su un campo FootPool durante una festa pubblica all'aperto",
        },
        messen: {
          t: "Fiere & promozioni",
          d: "Un'attrazione interattiva per fiere, promozioni e giornate speciali.",
          alt: "Impressioni di eventi FootPool con branding durante manifestazioni pubbliche",
        },
        schulen: {
          t: "Scuole",
          d: "Giornate sportive, campi scolastici e occasioni scolastiche speciali.",
          alt: "Scolari che giocano a FootPool con palle numerate",
        },
      },
    },
    gallery: {
      kicker: "Galleria",
      title: "L'energia FootPool in immagini.",
      alts: [
        "Campo FootPool brandizzato allestito in un ufficio",
        "Ospiti attorno al campo FootPool in una sala in mattoni",
        "Team che festeggia durante un evento FootPool in città",
        "Ospiti a una serata aziendale FootPool",
      ],
    },
    aiNote: {
      title: "INFORMAZIONI SULLE NOSTRE IMMAGINI",
      body:
        "FootPool Events debutta nel 2026. Alcune delle immagini presentate su questo sito sono quindi state create o rielaborate con l'IA per illustrare possibili eventi e situazioni FootPool. Non appena si svolgeranno le nostre prime manifestazioni, verranno progressivamente sostituite con fotografie di eventi FootPool reali.\nL'offerta, l'attrezzatura e le prestazioni indicate sono naturalmente indipendenti da queste immagini e del tutto reali.",
    },
    pricing: {
      kicker: "TRASPARENTE & INDIVIDUALE",
      title: "Prezzi & pacchetti",
      subtitle:
        "Tutti i prezzi sono da intendersi IVA esclusa. Prestazioni aggiuntive individuali e spese di trasferta vengono calcolate separatamente.",
      countryAria: "Seleziona il paese",
      countries: { CH: "Svizzera (CHF)", DE: "Germania (€)", AT: "Austria (€)" },
      from: "da",
      orgFrom: "Onorario organizzativo da",
      onRequest: "Prezzo su richiesta",
      perMonth: "/ mese",
      eventsTitle: "Eventi",
      eventsTag: "Employee experience",
      offers: {
        tryIt: {
          label: "TRY IT",
          title: "Per provare semplicemente",
          items: [
            "Fino a 12 persone",
            "2 ore di gioco",
            "1 campo FootPool",
            "Consegna, montaggio e smontaggio",
            "2 collaboratori FootPool",
            "Introduzione e assistenza",
          ],
        },
        makeItYours: {
          label: "MAKE IT YOURS",
          title: "Il vostro evento. La vostra esperienza.",
          items: [
            "Fino a 24 persone",
            "4 ore di gioco",
            "1 campo FootPool",
            "Consegna, montaggio e smontaggio",
            "Almeno 2 collaboratori FootPool",
            "Introduzione e assistenza",
            "Premiazione inclusa",
            "Modalità torneo organizzata su richiesta inclusa",
          ],
          note: "Le prestazioni aggiuntive opzionali vengono calcolate separatamente.",
        },
        weTakeCare: {
          label: "WE TAKE CARE OF IT",
          title: "Voi desiderate. Noi organizziamo.",
          desc: "Pianificazione e coordinamento individuali del vostro evento FootPool – in particolare per manifestazioni più grandi o complesse.",
          note: "L'onorario organizzativo comprende pianificazione e coordinamento. Campi, personale, trasporto e altre prestazioni operative vengono calcolati separatamente.",
        },
      },
      addonsTitle: "PRESTAZIONI AGGIUNTIVE",
      addons: [
        "Ora di gioco aggiuntiva",
        "Secondo campo incl. personale aggiuntivo",
      ],
      outdoorTitle: "OPZIONI ESTERNE",
      outdoor: [
        "Protezione dalle intemperie",
        "Riscaldamento",
        "Raffreddamento",
        "Protezione + riscaldamento o raffreddamento",
      ],
      inspiration: {
        title: "Valorizzate il vostro evento",
        body: "Catering, DJ, moderazione, fotografia, tecnica per eventi, attività aggiuntive, giveaway e possibilità di branding personalizzate – su richiesta.",
      },
      custom: {
        title: "Altri desideri? Rendiamo possibili molte cose.",
        body: "Le possibilità elencate sono solo una selezione. Raccontateci la vostra idea – ne verifichiamo la fattibilità e vi prepariamo un'offerta individuale.",
      },
      founding: {
        kicker: "FOUNDING CLIENT SEASON",
        title: "Dicembre 2026 – febbraio 2027",
        body1: "Protezione dalle intemperie con riscaldamento incluso a CHF 450 invece di CHF 570.",
        body2:
          "Offerta valida esclusivamente per la Founding Client Season svizzera e solo per questa combinazione. L'attività regolare inizia a marzo 2027.",
      },
      payment: {
        label: "Condizioni di pagamento per gli eventi:",
        text: "50 % alla prenotazione, il restante 50 % entro 7 giorni dall'evento.",
      },
      brandingTitle: "Branding",
      brandingTag: "Brand experience",
      branded: {
        label: "BRANDED FOOTPOOL",
        title: "Visibile in modo interattivo.",
        durations: ["3 mesi", "6 mesi", "12 mesi"],
        items: [
          "Presenza pubblicitaria su un campo di proprietà FootPool",
          "Utilizzo in occasione di eventi FootPool idonei e apparizioni pubbliche proprie",
          "Prova degli utilizzi effettivamente avvenuti",
          "Progettazione, produzione e applicazione del branding separatamente",
          "Nessun numero garantito di utilizzi o contatti",
          "Nessun uso esclusivo del campo da parte del cliente pubblicitario",
        ],
      },
      campaign: {
        label: "CAMPAIGN FOOTPOOL",
        title: "Raggiungere le persone in modo interattivo.",
        desc: "Noleggio esclusivo di un campo FootPool modulare per la vostra campagna.",
        rates: ["1–3 giorni, al giorno", "1 settimana", "1 mese"],
        items: [
          "Noleggio settimanale: 6 giorni di utilizzo, restituzione il 7° giorno.",
          "Noleggio mensile: 30 giorni di utilizzo, restituzione il 31° giorno.",
          "Trasporto, consegna, montaggio, personale, branding e altre prestazioni operative offerti separatamente.",
          "Proroghe possibili previo accordo.",
        ],
      },
      weTakeBrand: {
        label: "WE TAKE CARE OF IT",
        title: "Rendere il vostro marchio interattivo.",
        desc: "Pianificazione e coordinamento individuali di un'azione di marca legata a FootPool.",
        note: "L'onorario organizzativo copre pianificazione e coordinamento. Campi, branding, trasporto, personale e altre prestazioni vengono calcolati separatamente.",
      },
    },
    faq: {
      kicker: "FAQ",
      title: "Domande frequenti",
      intro:
        "Risposte alle domande più frequenti su FootPool, eventi e branding.",
      stillHave: "Avete ancora domande?",
      cta: "Contattateci",
      groups: [
        { label: "Generale" },
        { label: "Eventi & organizzazione" },
        { label: "Branding & campagne" },
      ],
      items: [
        { g: 0, q: "Che cos'è FootPool?", a: "FootPool unisce calcio e biliardo su un campo di grande formato. Invece della stecca, le palle si giocano con i piedi. Il risultato è un'esperienza interattiva che combina movimento, abilità e divertimento condiviso." },
        { g: 0, q: "Per chi è adatto FootPool?", a: "Per aziende, team, organizzazioni, associazioni, scuole e organizzatori. FootPool è adatto sia per eventi aziendali e team building, sia per fiere, promozioni e apparizioni di marca interattive." },
        { g: 0, q: "Serve una particolare forma fisica per FootPool?", a: "No. FootPool non richiede né una condizione particolare né conoscenze sportive. In primo piano ci sono abilità, precisione e il divertimento condiviso. Ognuno gioca al proprio ritmo." },
        { g: 0, q: "Quante persone possono giocare contemporaneamente?", a: "Di solito giocano una o due persone per squadra una contro l'altra. Grazie al susseguirsi delle partite possono partecipare anche gruppi più grandi. Le nostre offerte per eventi sono pensate per gruppi di diverse dimensioni." },
        { g: 0, q: "Con quali altri nomi è conosciuto questo gioco?", a: "A seconda della regione, FootPool è chiamato anche calcio biliardo, biliardo con i piedi, football billiards o soccer billard. Il principio è sempre lo stesso: biliardo giocato con i piedi su un campo di grande formato – da non confondere con il calcio balilla." },
        { g: 1, q: "Qual è la differenza tra TRY IT e MAKE IT YOURS?", a: "TRY IT offre un'esperienza FootPool assistita per un massimo di dodici persone con due ore di gioco. MAKE IT YOURS offre fino a 24 persone quattro ore di gioco, una premiazione e, su richiesta, una modalità torneo organizzata. L'esperienza può inoltre essere personalizzata con prestazioni aggiuntive come un tempo di gioco prolungato, un secondo campo, moderazione, protezione dalle intemperie, riscaldamento o raffreddamento. Queste prestazioni aggiuntive sono prenotabili separatamente." },
        { g: 1, q: "Cosa comprende WE TAKE CARE OF IT?", a: "Ci occupiamo della pianificazione e del coordinamento individuali del vostro evento FootPool. L'offerta si rivolge in particolare a manifestazioni più grandi o complesse. Le spese organizzative, i campi necessari e le prestazioni aggiuntive vengono indicati separatamente." },
        { g: 1, q: "Si può utilizzare FootPool all'interno e all'esterno?", a: "Sì. I requisiti sono spazio sufficiente e una superficie adeguata e piana. Verifichiamo insieme se il luogo desiderato è adatto." },
        { g: 1, q: "Quanto spazio occorre per il FootPool?", a: "Occorre uno spazio libero di almeno 10 × 4 metri, così da avere spazio sufficiente per giocare. Il FootPool può essere praticato sia al chiuso sia all'aperto." },
        { g: 1, q: "Cosa succede in caso di maltempo?", a: "Per gli eventi all'aperto offriamo come optional una protezione dalle intemperie e possibilità di riscaldamento o raffreddamento. Durante la nostra Founding Client Season, da dicembre 2026 a febbraio 2027, la combinazione di protezione dalle intemperie e riscaldamento è disponibile in Svizzera al prezzo speciale di CHF 450." },
        { g: 1, q: "Trasporto, montaggio e assistenza sono inclusi nel prezzo?", a: "Con TRY IT e MAKE IT YOURS, consegna, montaggio, smontaggio e assistenza fanno parte dell'offerta. Per eventi individuali e campagne di branding, l'entità delle prestazioni dipende dall'offerta concordata. Le spese di trasferta vengono calcolate separatamente." },
        { g: 2, q: "Come crea FootPool un valore aggiunto per branding e marketing?", a: "FootPool rende i marchi vivibili in modo interattivo. Invece di limitarsi a guardare la pubblicità, le persone diventano attive, giocano e conversano tra loro. Ne nascono attenzione, interazione e tempi di permanenza più lunghi – e quindi occasioni di incontri e conversazioni personali. Fiera, promozione, roadshow o campagna pubblica: FootPool crea spazio per il dialogo." },
        { g: 2, q: "Che cos'è BRANDED FOOTPOOL?", a: "Prenotate uno spazio pubblicitario su uno dei nostri campi FootPool. Il campo resta di nostra proprietà e viene utilizzato in occasione di eventi FootPool idonei e delle nostre apparizioni pubbliche. Un determinato numero di utilizzi o contatti non è garantito." },
        { g: 2, q: "Che cos'è CAMPAIGN FOOTPOOL?", a: "Con CAMPAIGN FOOTPOOL mettiamo a vostra disposizione un campo FootPool in esclusiva per la vostra campagna. La durata del noleggio può comprendere singoli giorni, una settimana o un mese. Trasporto, assistenza e branding vengono offerti separatamente secondo le esigenze." },
        { g: 2, q: "Possiamo far personalizzare il campo?", a: "Sì. A seconda dell'offerta, le superfici pubblicitarie e gli elementi di design idonei possono essere brandizzati individualmente. Progettazione, produzione e realizzazione vengono concordati separatamente." },
        { g: 2, q: "Possiamo far organizzare un'azione di branding completa?", a: "Sì. Con WE TAKE CARE OF IT vi supportiamo nella pianificazione e nell'organizzazione della vostra campagna FootPool. L'entità concreta delle prestazioni viene definita insieme." },
      ],
    },
    contact: {
      kicker: "CONTATTO",
      title: "Organizziamo il vostro prossimo evento.",
      subtitle:
        "Evento aziendale, festa di associazione, scuola o manifestazione pubblica — vi consigliamo personalmente e prepariamo un preventivo senza impegno.",
      emailLabel: "E-mail",
      phoneLabel: "Telefono",
      locationLabel: "Sede",
      locationValue: "9468 Sax, Svizzera",
      formIntro:
        "Inviateci alcune informazioni sul vostro evento. Vi risponderemo con una proposta adeguata.",
      requiredNote: "* Campi obbligatori",
      sections: {
        inquiry: "La vostra richiesta",
        details: "Dati di contatto",
        address: "Indirizzo di contatto",
        eventLocation: "Luogo dell'evento",
        additional: "Informazioni aggiuntive",
      },
      interestLabel: "Interessati a",
      interests: {
        events: "Eventi / team building",
        branding: "Branding / marketing",
        general: "Richiesta generale",
      },
      firstName: "Nome",
      lastName: "Cognome",
      company: "Azienda / organizzazione",
      optional: "Facoltativo",
      email: "Indirizzo e-mail",
      emailPlaceholder: "nome@esempio.ch",
      phone: "Numero di telefono",
      phonePlaceholder: "+41 …",
      street: "Via e numero civico",
      zip: "CAP",
      city: "Località",
      country: "Paese",
      countries: { CH: "Svizzera", DE: "Germania", AT: "Austria", other: "Altro paese" },
      countryOther: "Quale paese?",
      eventLoc: {
        same: "Uguale all'indirizzo di contatto",
        different: "Luogo dell'evento diverso",
        unknown: "Luogo dell'evento non ancora noto",
      },
      venue: "Location",
      expectedRegion: "Città / regione prevista",
      eventType: "Tipo di evento",
      eventTypes: {
        corporate: "Evento aziendale / team event",
        club: "Festa di associazione",
        private: "Festa privata",
        public: "Manifestazione pubblica / festival",
        school: "Scuola / formazione",
        other: "Altro",
      },
      selectPlaceholder: "Selezionare",
      dateMode: "Data desiderata / periodo",
      usagePeriod: "Periodo di utilizzo desiderato",
      fixed: "Data fissa",
      flexible: "Periodo flessibile",
      startDate: "Data di inizio",
      endDate: "Data di fine",
      oneDayHint: "Per un evento di un giorno è sufficiente la data di inizio.",
      flexiblePeriod: "Periodo",
      flexiblePlaceholder: "es. maggio 2027, preferibilmente venerdì o sabato",
      participants: "Numero approssimativo di partecipanti",
      participantsHint: "È sufficiente una stima.",
      participantsPlaceholder: "es. 30",
      expectedParticipants: "Partecipanti / visitatori previsti",
      message: "Messaggio / desideri particolari",
      messagePlaceholder: "Cosa dovremmo sapere sul vostro evento?",
      submit: "Invia richiesta non vincolante",
      submitting: "Invio in corso…",
      success:
        "Grazie mille! La vostra richiesta è stata salvata. Vi contatteremo.",
      error: "La richiesta non ha potuto essere inviata. Riprova.",
      errors: {
        required: "Campo obbligatorio",
        emailInvalid: "Inserire un indirizzo e-mail valido.",
        endBeforeStart: "La data di fine non può precedere la data di inizio.",
        participantsInvalid: "Inserire un numero intero positivo.",
      },
      privacyNoticePre:
        "I dati forniti vengono utilizzati per elaborare la Sua richiesta. Ulteriori informazioni sono disponibili nell'",
      privacyNoticeLink: "informativa sulla protezione dei dati",
    },
    footer: {
      tagline:
        "FootPool trasforma gli eventi aziendali in esperienze condivise e le apparizioni di marca in incontri interattivi.",
      location: "9468 Sax, Svizzera",
      navTitle: "Navigazione",
      contactTitle: "Contatto",
      links: [
        { href: "#home", label: "Home" },
        { href: "#events", label: "Eventi" },
        { href: "#branding", label: "Branding" },
        { href: "#pricing", label: "Prezzi" },
        { href: "#faq", label: "FAQ" },
        { href: "#contact", label: "Contatto" },
      ],
      rights: "Tutti i diritti riservati.",
      impressum: "Impressum",
      privacy: "Protezione dei dati",
    },
    legal: {
      closeAria: "Chiudi",
      dateLabel: "Aggiornato al:",
      impressum: {
        title: "Impressum",
        note:
          "Le informazioni sono fornite conformemente ai requisiti legali vigenti per i siti web in Svizzera. Non si assume alcuna responsabilità per i contenuti dei siti esterni collegati.",
      },
      privacy: {
        title: "Informativa sulla protezione dei dati",
        stand: "Aggiornata al: 16 ottobre 2026",
        sections: [
          {
            h: "Titolare per FootPool Events",
            paras: [
              "Petar Strajnic – FootPool Events\nWinggel 13\n9468 Sax, Svizzera\nE-mail: info@footpoolevents.ch",
            ],
          },
          {
            h: "Contatto e richieste",
            paras: [
              "Quando ci contattate, trattiamo i vostri dati per rispondere alla vostra richiesta, preparare un'offerta ed eventualmente preparare ed eseguire il vostro incarico.",
              "Ciò include i vostri dati di contatto e indirizzo, le informazioni sull'evento e il vostro messaggio. Per le richieste tramite modulo vengono inoltre salvati un numero di riferimento, il momento di ricezione e la lingua scelta.",
              "La memorizzazione avviene sulla nostra piattaforma di hosting Emergent. Le notifiche e le conferme di ricezione vengono inviate tramite il servizio e-mail integrato Resend. La nostra casella e-mail è gestita presso Hosttech.",
              "Non trasmettiamo i dati delle vostre richieste per la pubblicità di altre aziende. Non avviene attualmente alcun utilizzo da parte di altre unità aziendali del titolare.",
              "Nella misura in cui il GDPR è applicabile, trattiamo questi dati per misure precontrattuali e per l'esecuzione del contratto ai sensi dell'art. 6 par. 1 lett. b GDPR. Le altre corrispondenze vengono trattate sulla base del nostro legittimo interesse a rispondere alle richieste ai sensi dell'art. 6 par. 1 lett. f GDPR.",
            ],
          },
          {
            h: "Gestione del sito web",
            paras: [
              "Il sito web è ospitato presso Emergent e distribuito tramite Cloudflare. Dati tecnici di connessione come indirizzo IP, informazioni sul browser e momento dell'accesso vengono trattati per fornire e proteggere il sito. A questo scopo possono essere utilizzati cookie tecnicamente necessari.",
              "Nella misura in cui il GDPR è applicabile, ciò avviene sulla base del nostro legittimo interesse a una gestione sicura e affidabile del sito web ai sensi dell'art. 6 par. 1 lett. f GDPR.",
              "La vostra scelta della lingua viene salvata nella memoria locale del vostro browser. Potete eliminare questa impostazione cancellando i dati del sito nel vostro browser.",
            ],
          },
          {
            h: "Caratteri esterni",
            paras: [
              "Il sito carica i caratteri tramite Google Fonts. Il vostro indirizzo IP e i dati tecnici della richiesta vengono trasmessi a Google. È possibile un trattamento negli Stati Uniti.",
            ],
            links: [
              { label: "Ulteriori informazioni", url: "https://policies.google.com/privacy" },
            ],
          },
          {
            h: "Analisi da parte della piattaforma di hosting",
            paras: [
              "Emergent integra PostHog. Vengono registrati le pagine visitate e le interazioni; è inoltre attiva una registrazione delle sessioni. Per i campi di immissione è previsto un mascheramento. Il modulo di contatto è inoltre contrassegnato con un'indicazione di esclusione.",
              "L'integrazione è controllata da Emergent. Tramite la dashboard di Emergent, FootPool Events dispone di statistiche aggregate sui visitatori, ad esempio sulle pagine visitate, sulle fonti di accesso, sui paesi e sui tipi di dispositivo. Queste servono a valutare l'utilizzo e a migliorare la nostra presenza web. Non comportano un accesso diretto al progetto PostHog né alle registrazioni delle singole sessioni. L'integrazione PostHog finora esaminata trasmette dati di analisi negli Stati Uniti.",
              "Le informazioni sul trattamento dei dati da parte dei fornitori e i contatti per le relative domande sono disponibili qui:",
            ],
            links: [
              { label: "Emergent protezione dei dati", url: "https://www.app.emergentagent.sh/privacy-policy" },
              { label: "PostHog protezione dei dati", url: "https://posthog.com/privacy" },
            ],
          },
          {
            h: "Fornitori di servizi e trattamento all'estero",
            paras: [
              "Per la gestione del sito web e la comunicazione vengono impiegati Emergent, Cloudflare, Resend e Hosttech. Attraverso le integrazioni descritte, anche Google e PostHog ricevono dati.",
              "Emergent indica Stati Uniti, UE e India come luoghi di trattamento dei propri servizi. Resend memorizza i contenuti delle e-mail e i dati di invio negli Stati Uniti. La nostra casella e-mail Hosttech è memorizzata in Svizzera nell'ambito del web hosting svizzero.",
              "Resend prevede clausole contrattuali standard con adattamenti per la Svizzera per i trasferimenti internazionali di dati. PostHog cita le clausole contrattuali standard e la partecipazione allo Swiss–U.S. ed EU–U.S. Data Privacy Framework.",
              "Ulteriori informazioni dei fornitori:",
            ],
            links: [
              { label: "Contratto di trattamento dei dati Emergent", url: "https://app.emergent.sh/dpa" },
              { label: "Subincaricati Emergent", url: "https://app.emergent.sh/subprocessors" },
              { label: "Cloudflare protezione dei dati", url: "https://www.cloudflare.com/privacypolicy/" },
              { label: "Resend protezione dei dati e trasferimenti", url: "https://resend.com/security/gdpr" },
              { label: "Hosttech protezione dei dati", url: "https://www.hosttech.ch/datenschutz/" },
            ],
          },
          {
            h: "Conservazione",
            paras: [
              "Conserviamo i dati delle vostre richieste e la corrispondenza per il tempo necessario all'elaborazione, all'esecuzione degli incarichi o alla tutela di diritti legali. Restano riservati gli obblighi legali di conservazione. Successivamente i dati vengono cancellati o resi anonimi.",
              "Per l'analisi controllata da Emergent si applicano le regole di conservazione dei fornitori coinvolti.",
            ],
          },
          {
            h: "I vostri diritti",
            paras: [
              "In conformità con la legge applicabile in materia di protezione dei dati, potete richiedere l'accesso, la rettifica o la cancellazione dei vostri dati personali. Se applicabile, avete inoltre i diritti di limitazione del trattamento, di portabilità dei dati e di opposizione. Potete revocare in qualsiasi momento un consenso prestato con effetto per il futuro.",
              "Contatto: info@footpoolevents.ch",
              "Potete inoltre rivolgervi all'autorità di vigilanza competente in materia di protezione dei dati: in Svizzera all'IFPDT, in Germania all'autorità regionale competente e in Austria all'autorità per la protezione dei dati.",
            ],
          },
        ],
      },
    },
    seo: {
      htmlLang: "it",
      ogLocale: "it_CH",
      title: "FootPool Events – Calcio biliardo per eventi aziendali & branding",
      description:
        "FootPool – chiamato anche calcio biliardo o biliardo con i piedi: per eventi aziendali, attività di team building e animazioni di marca. Mobile, dalla Svizzera orientale in tutta la Svizzera.",
      ogTitle: "FootPool Events — Il calcio incontra il biliardo. Le persone incontrano i marchi.",
      ogDescription:
        "Eventi aziendali assistiti, attività di team building e animazioni di marca interattive con FootPool: calcio e biliardo su un campo di grande formato – mobile in tutta la Svizzera.",
      twitterTitle: "FootPool Events – Calcio biliardo per eventi & branding",
      twitterDescription:
        "Eventi aziendali assistiti e animazioni di marca interattive con FootPool, dalla Svizzera orientale in tutta la Svizzera.",
      keywords:
        "footpool, calcio biliardo, biliardo con i piedi, football billiards, noleggio calcio biliardo, evento aziendale, team building, animazione fieristica, centri commerciali, svizzera",
      ogImageAlt: "Campo FootPool durante un evento aziendale serale",
    },
  },
};
